module.exports = __webpack_public_path__ + "img/square-regular.343596b4.svg";